<template>
  <div>
    <div :class="`button-amount ${selectedAdsType ? 'border-bottom' : ''} `">      
      <v-radio-group v-model="selectedAdsType">
        <v-radio
          v-for="(item, index) in adsTypeList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></v-radio>
      </v-radio-group>
    </div>

    <app-side-panel-ads-gpt v-if="isGpt"
                            :data-interaction="interaction"
                            @update="update"
                            @add-option="addOption"
                            @update-option="updateOption"
                            @remove-option="removeOption"
                            @reload="reloadOptions"></app-side-panel-ads-gpt>

    <app-side-panel-ads-vast v-if="isVast"
                            :data-interaction="interaction"
                            @input="update"
                            @update-option="updateOption"></app-side-panel-ads-vast>

  </div>
</template>

<script>
    import AppSidePanelAdsGpt from './gpt/SidePanelAdsGpt.vue'
    import AppSidePanelAdsVast from './vast/SidePanelAdsVast.vue'
    import panelBody from '../../mixins/panel-body'

    export default {
      components:{
        AppSidePanelAdsGpt,
        AppSidePanelAdsVast
      },
      data() {
        return {
          adsTypeList: [
            {label: 'GPT', value: 'GOOGLE_PUBLISHER_TAG' },
            {label: 'VAST', value: 'VAST' },
          ],            
        }
      },
      props: {
        selectedType: {
          type: String,
          required: true,
        }
      },

      computed: {
        isGpt() {
          return this.selectedType === 'GOOGLE_PUBLISHER_TAG'
        },
        isVast() {
          return this.selectedType === 'VAST'
        },
        selectedAdsType: {
          get() {
            return this.selectedType
          },
          set(val) {
            this.selectSurvey(val)
          }
        }
      },

      mixins: [panelBody],

      methods: {
          selectSurvey(type) {
          this.$emit('selectType', type);
          },
          update(evt) {
            this.$emit('update', evt);
          },
          addOption() {
            this.$emit('add-option');
          },
          updateOption(data){
            this.$emit('update-option', data);
          },
          removeOption(option){
            this.$emit('remove-option', option);
          },
          reloadOptions() {
            this.$emit('reload')
          }
      }
    }
</script>

<style lang="scss" scoped>
@import "../../mixins/panel-body";

.button-amount { 
  padding: 10px 30px 0 10px;
  font-size: 14px;
  font-weight: bold;

  .checkbox-wrapper {
    display: flex;
    align-items: center;

    .text {
      margin: 4px 0 0 -6px;
    }

    ::v-deep .v-input {
      flex: 0
    }    
  }

  ::v-deep .v-input--selection-controls {
    margin-top: 0;
  }
  ::v-deep .v-input__slot {
    margin-bottom: 0;
  }
  ::v-deep .v-label {
    font-size: 14px;
  }
}
</style>

